<template>
  <div class="jd">
    <el-tabs v-model="activeName" @tab-click="cutTab" v-loading="loading" element-loading-text="拼命加载中">
      <el-tab-pane label="推广信息" name="1">
        <el-form v-if="activeName === '1'" ref="form" :model="form" :rules="rules">
          <div class="common-form">推广码</div>
          <el-form-item prop="promotionCode">
            <el-input v-model="form.promotionCode" placeholder="请输入" type="textarea" :rows="5"  style="width: 95%;"></el-input>
          </el-form-item>
          <!-- <div class="common-form">项目信息</div>
          <el-form-item prop="projectInformation">
            <Uediter v-if="form.projectInformation" :key="1" :text="form.projectInformation" :config="ueditor.config" id="projectInformation"
              @contentChange="contentChangeFunc($event, 'projectInformation')" />
          </el-form-item>
          <div class="common-form">相关教程</div>
          <el-form-item prop="relatedTutorials">
            <Uediter :key="2" :text="form.relatedTutorials" :config="ueditor.config" id="relatedTutorials"
              @contentChange="contentChangeFunc($event, 'relatedTutorials')" />
          </el-form-item> -->
          <div class="common-button-wrapper">
            <el-button type="primary" @click="onSubmit(1)" :loading="submitLoading">提交</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="佣金配置" name="2">
        <el-table :data="configurationData" border>
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column label="新商家数量" width="300">
            <template slot-scope="scope">
              <div class="flex flex-middle">
                <el-input v-model="scope.row.startMerchant" :controls="false" :min="0" :precision="0" placeholder="请输入"
                  @input="handleInput(scope.$index, 'startMerchant', $event)">
                </el-input>
                <span class="line">~</span>
                <el-input v-model="scope.row.endMerchant" :controls="false" :min="0" :precision="0" placeholder="请输入"
                  @input="handleInput(scope.$index, 'endMerchant', $event)">
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="资料审核佣金">
            <template slot-scope="scope">
              <el-input v-model="scope.row.informationMoney" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput2(scope.$index, 'informationMoney', $event)" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="产品上线佣金（自主上线）">
            <template slot-scope="scope">
              <el-input v-model="scope.row.userProductMoney" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput2(scope.$index, 'userProductMoney')" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="产品上线佣金（平台上线）">
            <template slot-scope="scope">
              <el-input v-model="scope.row.platformProductMoney" placeholder="请输入" :controls="false" :min="0"
                :precision="2" @input="handleInput2(scope.$index, 'platformProductMoney')" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="直推">
            <template slot-scope="scope">
              <el-input v-model="scope.row.direct" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput2(scope.$index, 'direct', $event)" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="间推">
            <template slot-scope="scope">
              <el-input v-model="scope.row.indirect" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput2(scope.$index, 'indirect', $event)" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="delTable(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="width:100%;;display:block;" @click="addTable()">新增配置</el-button>
        <div class="common-button-wrapper" style="position: absolute;">
          <el-button type="primary" @click="onSubmit(2)" :loading="submitLoading">提交</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="月结配置" name="3">
        <el-table :data="monthData" border>
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column label="订单数" width="300">
            <template slot-scope="scope">
              <div class="flex flex-middle">
                <el-input v-model="scope.row.startOrder" :controls="false" :min="0" :precision="0" placeholder="请输入"
                  @input="handleInput3(scope.$index, 'startOrder', $event)">
                </el-input>
                <span class="line">~</span>
                <el-input v-model="scope.row.endOrder" :controls="false" :min="0" :precision="0" placeholder="请输入"
                  @input="handleInput3(scope.$index, 'endOrder', $event)">
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              <el-input v-model="scope.row.money" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput4(scope.$index, 'money', $event)" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="直推">
            <template slot-scope="scope">
              <el-input v-model="scope.row.direct" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput4(scope.$index, 'direct', $event)" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="间推">
            <template slot-scope="scope">
              <el-input v-model="scope.row.indirect" placeholder="请输入" :controls="false" :min="0" :precision="2"
                @input="handleInput4(scope.$index, 'indirect', $event)" style="width: 100%;">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="delTable2(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="width:100%;;display:block;" @click="addTable2()">新增配置</el-button>
        <div class="common-button-wrapper" style="position: absolute;">
          <el-button type="primary" @click="onSubmit(3)" :loading="submitLoading">提交</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="申请审核" name="4">
        <div class="searchform">
          <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="用户名称"><el-input size="small" v-model="searchForm.userName" placeholder="请输入"
                clearable></el-input></el-form-item>
            <el-form-item label="商家编号"><el-input size="small" v-model="searchForm.merchantId" placeholder="请输入"
                clearable></el-input></el-form-item>
            <el-form-item label="申请时间">
              <div class="block">
                <span class="demonstration"></span>
                <el-date-picker size="small" v-model="searchForm.applicationTime" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="资料审核状态">
              <el-select size="small" v-model="searchForm.informationStatus" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="驳回" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品上架状态">
              <el-select size="small" v-model="searchForm.productStatus" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="0"></el-option>
                <el-option label="自主上架通过" value="1"></el-option>
                <el-option label="平台上架通过" value="2"></el-option>
                <el-option label="驳回" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="京东审核状态">
              <el-select size="small" v-model="searchForm.shzt" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="BD驳回" value="BD驳回"></el-option>
                <el-option label="招商审核通过" value="招商审核通过"></el-option>
                <el-option label="待BD审核" value="待BD审核"></el-option>
                <el-option label="客服驳回" value="客服驳回"></el-option>
                <el-option label="客服审核通过" value="客服审核通过"></el-option>
                <el-option label="待客服审核" value="待客服审核"></el-option>
                <el-option label="OA审核通过" value="OA审核通过"></el-option>
                <el-option label="已生效" value="已生效"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资料审核通过30天">
              <el-select size="small" v-model="searchForm.isMonth" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算方式">
              <el-select size="small" v-model="searchForm.settlementType" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="日结" value="0"></el-option>
                <el-option label="月结" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
                @click="onSearch">查询</el-button></el-form-item>
            <el-form-item><el-button v-loading="exportLoading" size="small" type="success" @click="onExport"
                v-auth="'/order/operate/export'">导出</el-button></el-form-item>
            <el-form-item><el-button size="small" type="primary" icon="el-icon-search" <el-upload
                class="upload-demo btn" multiple action="string" :accept="'.xlsx, .xls'" :before-upload="beforeUpload"
                :on-error="onError" :show-file-list="false" :http-request="onSuccess2">
                <el-button type="primary" icon="el-icon-plus" class="btn" :loading="importLoading">导入订单信息</el-button>
                </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <el-table size="small" :data="tableData" border style="width: 100%;margin-top:20px;">
          <el-table-column prop="createByName" label="用户名"></el-table-column>
          <el-table-column prop="merchantId" label="商家编号"></el-table-column>
          <el-table-column prop="merchantCode" label="门店编号"></el-table-column>
          <el-table-column prop="shopName" label="店铺名称"></el-table-column>
          <el-table-column prop="businessLicenseName" label="营业执照名称"></el-table-column>
          <el-table-column prop="merchantFullName" label="商家姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="businessAddress" label="经营地址"></el-table-column>
          <el-table-column prop="applicationTime" label="申请时间"></el-table-column>
          <el-table-column prop="productType" label="产品申请方式">
            <template slot-scope="scope">{{ scope.row.productType === 0 ? '自主上线' : scope.row.productType === 1 ? '平台上线'
              : '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="createByName" label="资料审核状态">
            <template slot-scope="scope">{{
              scope.row.informationStatus === 1 ? '通过' : scope.row.informationStatus === 2 ? '驳回' : '待审核' }}</template>
          </el-table-column>
          <el-table-column prop="productStatus" label="产品上架状态">
            <template slot-scope="scope">{{
              scope.row.productStatus === 0 ? '待审核' : scope.row.productStatus === 1 ? '自主上架通过' : scope.row.productStatus
                === 2 ? '平台上架通过' : scope.row.productStatus === 3 ? '驳回' : '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="shzt" label="京东审核状态"></el-table-column>
          <el-table-column prop="shyj" label="京东审核意见"></el-table-column>
          <el-table-column prop="settlementType" label="结算方式">
            <template slot-scope="scope">{{
              scope.row.settlementType === 0 ? '日结' : scope.row.settlementType === 1 ? '月结' : '---' }}</template>
          </el-table-column>
          <el-table-column prop="informationDays" label="资料审核距今天数"></el-table-column>
          <el-table-column prop="orderNum" label="订单数"></el-table-column>
          <el-table-column prop="orderImportTime" label="订单数更新时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="look(scope.row)" type="text" size="small">查看</el-button>
              <el-button v-if="scope.row.informationStatus === 0" @click="audit(scope.row, 1)" type="text"
                size="small">资料审核</el-button>
              <el-button v-if="scope.row.informationStatus === 1 && scope.row.productStatus === 0"
                @click="audit(scope.row, 2)" type="text" size="small">产品审核</el-button>
              <el-button
                v-if="scope.row.commissionMonthStatus === 0 && scope.row.settlementType=== 1 && scope.row.informationStatus === 1 && scope.row.informationDays>=30"
                @click="audit(scope.row, 3)" type="text" size="small">月结审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
            :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="招商审核页面" name="5">
        <div class="searchform">
          <el-form size="small" :inline="true" :model="searchForm2" class="demo-form-inline">
            <el-form-item label="公司名称"><el-input size="small" v-model="searchForm2.gsmc" placeholder="请输入"
                clearable></el-input></el-form-item>
            <el-form-item label="商家编号"><el-input size="small" v-model="searchForm2.shbh" placeholder="请输入"
                clearable></el-input></el-form-item>
            <el-form-item label="商家分类"><el-input size="small" v-model="searchForm2.sjfl" placeholder="请输入"
                clearable></el-input></el-form-item>
            <el-form-item label="审核状态">
              <el-select size="small" v-model="searchForm2.shzt" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="BD驳回" value="BD驳回"></el-option>
                <el-option label="招商审核通过" value="招商审核通过"></el-option>
                <el-option label="待BD审核" value="待BD审核"></el-option>
                <el-option label="客服驳回" value="客服驳回"></el-option>
                <el-option label="客服审核通过" value="客服审核通过"></el-option>
                <el-option label="待客服审核" value="待客服审核"></el-option>
                <el-option label="OA审核通过" value="OA审核通过"></el-option>
                <el-option label="已生效" value="已生效"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="申请时间">
              <div class="block">
                <span class="demonstration"></span>
                <el-date-picker size="small" v-model="searchForm2.createTime" type="daterange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="mt">
                <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch2"
                  style="margin-right:10px;">查询</el-button>
                <el-button size="small" :loading="btnLoading" type="primary" icon="el-icon-refresh" @click="synchronous"
                  style="margin-right:10px;">同步</el-button>
                <el-button size="small" type="success" @click="onExport2">导出</el-button>
                <!-- <el-upload class="upload-demo btn" multiple action="string" :accept="'.xlsx, .xls'"
                  :before-upload="beforeUpload" :on-error="onError" :show-file-list="false" :http-request="onSuccess">
                  <el-button type="primary" icon="el-icon-plus" class="btn" :loading="importLoading">导入</el-button>
                </el-upload> -->
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-table size="small" :data="tableData2" border style="width: 100%;margin-top:20px;">
          <el-table-column prop="sjbh" label="商家编号"></el-table-column>
          <el-table-column prop="gsmc" label="公司名称"></el-table-column>
          <el-table-column prop="sjfl" label="商家分类"></el-table-column>
          <el-table-column prop="fwcs" label="服务城市"></el-table-column>
          <el-table-column prop="shyj" label="审核意见"></el-table-column>
          <el-table-column prop="sqsj" label="申请时间"></el-table-column>
          <el-table-column prop="gxsj" label="更新时间"></el-table-column>
          <el-table-column prop="shzt" label="审核状态"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" background
            :current-page="curPage2" :page-size="pageSize2" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber2">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="类目管理" name="6">
        <div class="searchform">
          <el-form size="small" :inline="true" :model="searchForm3" class="demo-form-inline">
            <el-form-item label="类型名称"><el-input size="small" v-model="searchForm3.name" placeholder="请输入"
                clearable></el-input></el-form-item>
            <el-form-item label="类型">
              <el-select size="small" v-model="searchForm3.type" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="项目信息" value="0"></el-option>
                <el-option label="相关教程" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
                @click="onSearch3">查询</el-button></el-form-item>
            <el-form-item> <el-button size="small" type="primary" icon="el-icon-plus"
                @click="showCategoryModal('categoryForm')">新增</el-button></el-form-item>
          </el-form>
        </div>

        <el-table size="small" :data="tableData3" border style="width: 100%;margin-top:20px;">
          <el-table-column prop="shbh" label="类型">
            <template slot-scope="scope">
              {{ scope.row.type === '0' ? '项目信息' : scope.row.type === '1' ? '相关教程' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="类目名称"></el-table-column>
          <el-table-column prop="status" label="是否启用">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="editCategory(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="delCategory(scope.row)" type="text" size="small" style="color:#f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" background
            :current-page="curPage3" :page-size="pageSize3" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber3">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="内容管理" name="7">
        <div class="searchform">
          <el-form size="small" :inline="true" :model="searchForm4" class="demo-form-inline">
            <el-form-item label="类型">
              <el-select size="small" v-model="searchForm4.type" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="项目信息" value="0"></el-option>
                <el-option label="相关教程" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
                @click="onSearch4">查询</el-button></el-form-item>
            <el-form-item> <el-button size="small" type="primary" icon="el-icon-plus"
                @click="showContentModal('categoryForm')">新增</el-button></el-form-item>
          </el-form>
        </div>

        <el-table size="small" :data="tableData4" border style="width: 100%;margin-top:20px;">
          <el-table-column prop="shbh" label="类型">
            <template slot-scope="scope">
              {{ scope.row.type === '0' ? '项目信息' : scope.row.type === '1' ? '相关教程' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="categoryName" label="所属类目"></el-table-column>
          <el-table-column prop="content" label="内容" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="editContent(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="delContent(scope.row)" type="text" size="small" style="color:#f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4" background
            :current-page="curPage4" :page-size="pageSize4" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber4">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="审核" :visible.sync="dialogVisible" @close='dialogVisible = false' :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form ref="auditForm" size="small" :model="auditForm" :rules="auditRules">
        <el-form-item v-if="type === 1" label="审核状态" prop="status">
          <el-select v-model="auditForm.status" placeholder="请选择" style="width:100%">
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="type === 2" label="审核状态" prop="status">
          <el-select v-model="auditForm.status" placeholder="请选择" style="width:100%">
            <el-option v-for="(item, index) in statusList2" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="(type === 1 && auditForm.status === '1') || (type === 2 && auditForm.status != '3')"
          label="通过凭证" prop="reason">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="auditForm.imgs">
              <transition-group>
                <div class="item" v-for="(item2, index2) in auditForm.imgs" :key="item2.filePath">
                  <img v-img-url="item2.filePath" />
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index2)"><i
                      class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
          </div>
        </el-form-item>
        <el-form-item v-if="(type === 1 && auditForm.status === '2') || (type === 2 && auditForm.status === '3')"
          label="驳回原因" prop="reason">
          <el-input v-model="auditForm.reason" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="type === 3" label="订单数">
          <p>{{auditForm.orderNum}}</p>
        </el-form-item>
        <el-form-item v-if="type === 3" label="月结金额" prop="money">
          <el-input v-model="auditForm.money" autocomplete="off" @input="handleInput5()"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goAudit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看" :visible.sync="lookdialogVisible" @close='lookdialogVisible = false'
      :close-on-click-modal="false" :close-on-press-escape="false" width="70%">
      <div class="common-form">详情信息</div>
      <div class="table-wrap">
        <div class="item">
          <span class="name">用户名：</span>
          <span class="value">{{ selectData.createByName }}</span>
        </div>
        <div class="item">
          <span class="name">商家编号：</span>
          <span class="value">{{ selectData.merchantId }}</span>
        </div>
        <div class="item">
          <span class="name">门店编号：</span>
          <span class="value">{{ selectData.merchantCode }}</span>
        </div>
        <div class="item">
          <span class="name">店铺名称：</span>
          <span class="value">{{ selectData.shopName }}</span>
        </div>
        <div class="item">
          <span class="name">营业执照：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.businessLicenseUrl" :key="index"
              style="width: 50px; height: 50px" :src="item" :preview-src-list="selectData.businessLicenseUrl">
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="name">营业执照名称：</span>
          <span class="value">{{ selectData.businessLicenseName }}</span>
        </div>
        <div class="item">
          <span class="name">商家姓名：</span>
          <span class="value">{{ selectData.merchantFullName }}</span>
        </div>
        <div class="item">
          <span class="name">手机号：</span>
          <span class="value">{{ selectData.phone }}</span>
        </div>
        <div class="item">
          <span class="name">经营地址：</span>
          <span class="value">{{ selectData.businessAddress }}</span>
        </div>
        <div class="item">
          <span class="name">商家门头照片：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.merchantPhotos" :key="index" style="width: 50px; height: 50px"
              :src="item" :preview-src-list="selectData.merchantPhotos">
            </el-image>
          </div>
        </div>
        <div v-if="selectData.merchantQrCodeUrl" class="item">
          <span class="name">群聊二维码：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image style="width: 50px; height: 50px" :src="selectData.merchantQrCodeUrl"
              :preview-src-list="[selectData.merchantQrCodeUrl]">
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="name">申请时间：</span>
          <span class="value">{{ selectData.applicationTime }}</span>
        </div>
        <div class="item">
          <span class="name">资料审核状态：</span>
          <span class="value">{{
            selectData.informationStatus === 1 ? '通过' : selectData.informationStatus === 2 ? '驳回' : '待审核' }}</span>
        </div>
        <div class="item">
          <span class="name">资料审核时间：</span>
          <span class="value">{{ selectData.informationExamineTime }}</span>
        </div>
        <div v-if="selectData.informationStatus === 2" class="item">
          <span class="name">资料驳回原因：</span>
          <span class="value">{{ selectData.informationExamineReason }}</span>
        </div>
        <div class="item">
          <span class="name">产品上架状态：</span>
          <span class="value">{{
            selectData.productStatus === 0 ? '待审核' : selectData.productStatus === 1 ? '自主上架通过' :
              selectData.productStatus
                === 2 ? '平台上架通过' : selectData.productStatus === 3 ? '驳回' : '--'
          }}</span>
        </div>
        <div class="item">
          <span class="name">产品上架审核时间：</span>
          <span class="value">{{ selectData.productExamineTime }}</span>
        </div>
        <div v-if="selectData.productStatus === 3" class="item">
          <span class="name">产品上架驳回原因：</span>
          <span class="value">{{ selectData.productExamineReason }}</span>
        </div>
        <div class="item">
          <span class="name">京东审核状态：</span>
          <span class="value">{{ selectData.shzt }}</span>
        </div>
        <div class="item">
          <span class="name">京东审核意见：</span>
          <span class="value">{{ selectData.shyj }}</span>
        </div>
        <div class="item">
          <span class="name">产品申请方式：</span>
          <span class="value">{{ selectData.productType === 0 ? '自主上线' : selectData.productType === 1 ? '平台上线'
            : '--'
          }}</span>
        </div>
        <div class="item">
          <span class="name">结算方式：</span>
          <span class="value">{{ selectData.settlementType === 0 ? '日结' : selectData.settlementType === 1 ? '月结'
            : '--'
          }}</span>
        </div>
        <div v-if="selectData.productType === 0 && selectData.independentlyLink" class="item">
          <span class="name">自主上线链接：</span>
          <a class="value" target="_blank" :href="selectData.independentlyLink">{{ selectData.independentlyLink }}</a>
        </div>
        <div
          v-if="selectData.productType === 0 && selectData.independentlyListedImages && selectData.independentlyListedImages.length"
          class="item">
          <span class="name">SKU凭证：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.independentlyListedImages" :key="index"
              style="width: 50px; height: 50px" :src="item" :preview-src-list="selectData.independentlyListedImages">
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="name">实名认证：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.realNameImages" :key="index" style="width: 50px; height: 50px"
              :src="item" :preview-src-list="selectData.realNameImages">
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="name">测试订单：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.testOrderImages" :key="index" style="width: 50px; height: 50px"
              :src="item" :preview-src-list="selectData.testOrderImages">
            </el-image>
          </div>
        </div>
        <!-- <div class="item">
          <span class="name">上传资质：</span>
          <div class="imgs flex-wrap" style="display: flex;">
                <el-image v-for="(item, index) in selectData.qualificationsImages" :key="index"
                  style="width: 50px; height: 50px" :src="item" :preview-src-list="selectData.qualificationsImages">
                </el-image>
              </div>
        </div> -->
        <div class="item">
          <span class="name">绑定银行卡：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.bindingBankCardImages" :key="index"
              style="width: 50px; height: 50px" :src="item" :preview-src-list="selectData.bindingBankCardImages">
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="name">签约京东钱包：</span>
          <div class="imgs flex-wrap" style="display: flex;">
            <el-image v-for="(item, index) in selectData.jdWalletImages" :key="index" style="width: 50px; height: 50px"
              :src="item" :preview-src-list="selectData.jdWalletImages">
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="name">订单数量：</span>
          <span class="value">{{ selectData.orderNum }}</span>
        </div>
        <div class="item">
          <span class="name">资料审核通过距今：</span>
          <span class="value">{{ selectData.informationDays }}天</span>
        </div>
        <div class="item" v-if="selectData.settlementType === 1">
          <span class="name">月结状态：</span>
          <span class="value">{{ selectData.commissionMonthStatus === 0 ? '未发放' : selectData.commissionMonthStatus === 1 ? '已发放'
            : '--'
          }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="lookdialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片</Upload>
    <el-dialog :title="categoryForm.id ? '编辑类目' : '新增类目'" :visible.sync="categoryModalVisible"
      @close='categoryModalVisible = false' :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="categoryForm" size="small" :model="categoryForm" :rules="categoryRules">
        <el-form-item label="类型" prop="type">
          <el-select v-model="categoryForm.type" placeholder="请选择" style="width:100%">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类目名称" prop="name">
          <el-input size="small" v-model="categoryForm.name" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="categoryForm.status" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="categoryModalVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCategory" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="contentForm.id ? '编辑内容' : '新增内容'" :visible.sync="contentModalVisible"
      @close='contentModalVisible = false' :close-on-click-modal="false" :close-on-press-escape="false" width="70%">
      <el-form ref="contentForm" size="small" :model="contentForm" :rules="contentRules">
        <el-form-item label="类型" prop="type">
          <el-select v-model="contentForm.type" placeholder="请选择" style="width:100%" @change="handleChange">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属类目" prop="categoryId">
          <el-select v-model="contentForm.categoryId" placeholder="请选择" style="width:100%">
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <Uediter v-if="contentModalVisible" :key="3" :text="contentForm.content" :config="ueditor.config" id="content"
            @contentChange="contentChangeFunc2" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentModalVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveContent" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新cookie" :visible.sync="cookieDialogVisible" @close='cookieDialogVisible = false'
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-input type="textarea" :rows="6" placeholder="请输入cookie" v-model="jddjCookies">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cookieDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCookie" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <JdLogin v-if="showJdLoginModal" @closeDialog="closeDialogFunc" />
  </div>
</template>

<script>
  import Uediter from '@/components/UE.vue';
  import jingdongApi from '@/api/plus/jingdong.js';
  import {
    getCookie
  } from '@/utils/base.js';
  import qs from "qs";
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  import JdLogin from './components/jdLogin.vue'




  export default {
    components: {
      Uediter,
      Upload,
      draggable,
      JdLogin
    },
    data() {
      return {
        activeName: '',
        form: {
          promotionCode: "",
          // projectInformation: "",
          // relatedTutorials: ""
        },
        rules: {
          promotionCode: [{
            required: true,
            message: '请输入推广码',
            trigger: 'blur'
          }],
          // projectInformation: [{
          //   required: true,
          //   message: '请输入项目信息',
          //   trigger: 'blur'
          // }],
          // relatedTutorials: [{
          //   required: true,
          //   message: '请输入相关教程',
          //   trigger: 'blur'
          // }],
        },
        auditRules: {
          status: [{
            required: true,
            message: '请选择审核状态',
            trigger: 'change'
          }],
          reason: [{
            required: true,
            message: '请输入驳回原因',
            trigger: 'blur'
          }],
          money: [{
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }],
        },
        categoryRules: {
          type: [{
            required: true,
            message: '请选择类型',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: '请输入类目名称',
            trigger: 'blur'
          }],
        },
        ueditor: {
          config: {
            initialFrameWidth: 600,
            initialFrameHeight: 500,
            zIndex: 99999
          },
        },
        loading: false,
        submitLoading: false,
        configurationData: [{
          startMerchant: null,
          endMerchant: null,
          informationMoney: null,
          userProductMoney: null,
          platformProductMoney: null,
          direct: null,
          indirect: null
        }],
        monthData: [{
          startOrder: null,
          endOrder: null,
          money: null
        }],
        tableData: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        pageSize: 15,
        pageSize2: 15,
        pageSize3: 15,
        pageSize4: 15,
        totalDataNumber: 0,
        totalDataNumber2: 0,
        totalDataNumber3: 0,
        totalDataNumber4: 0,
        curPage: 1,
        curPage2: 1,
        curPage3: 1,
        curPage4: 1,
        dialogVisible: false,
        lookdialogVisible: false,
        auditForm: {
          status: '',
          reason: "",
          imgs: [],
          orderNum: '',
          money: ''
        },
        statusList: [{
            label: '通过',
            value: '1'
          },
          {
            label: '驳回',
            value: '2'
          }
        ],
        statusList2: [{
            label: '自主上架通过',
            value: '1'
          },
          {
            label: '平台上架通过',
            value: '2'
          },
          {
            label: '驳回',
            value: '3'
          }
        ],
        selectData: {},
        type: 1,
        searchForm: {
          userName: '',
          merchantId: '',
          merchantName: '',
          applicationTime: [],
          startTime: '',
          endTime: '',
          informationStatus: '',
          productStatus: '',
          isMonth: '',
          settlementType:''
        },
        exportLoading: false,
        searchForm2: {
          gsmc: '',
          shbh: '',
          sjfl: '',
          shzt: '',
          createTime: [],
          startTime: '',
          endTime: ''
        },
        file: null,
        importLoading: false,
        searchForm3: {
          name: '',
          type: ''
        },
        typeList: [{
            label: '项目信息',
            value: '0'
          },
          {
            label: '相关教程',
            value: '1'
          }
        ],
        categoryModalVisible: false,
        categoryForm: {
          type: '',
          name: '',
          status: 1
        },
        config: {

        },
        isProductUpload: false,
        file_name: 'image',
        contentModalVisible: false,
        contentForm: {
          id: '',
          type: '',
          categoryId: '',
          content: ''
        },
        categoryList: [],
        searchForm4: {
          type: ''
        },
        contentRules: {
          type: [{
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }],
          categoryId: [{
            required: true,
            message: '请选择所属类目',
            trigger: 'change'
          }],
          content: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }],
        },
        cookieDialogVisible: false,
        jddjCookies: '',
        btnLoading: false,
        showJdLoginModal: false

      }
    },
    watch: {
      'searchForm.applicationTime': {
        handler(newVal) {
          // 当 applicationTime 变化时执行的逻辑
          console.log('applicationTime changed:', newVal);
          if (newVal) {
            this.searchForm.startTime = newVal[0]
            this.searchForm.endTime = newVal[1]
          } else {
            this.searchForm.startTime = ''
            this.searchForm.endTime = ''
          }
        },
        immediate: true // 如果你希望在组件创建时立即执行一次
      },
      'searchForm2.createTime': {
        handler(newVal) {
          // 当 createTime 变化时执行的逻辑
          console.log('createTime changed:', newVal);
          if (newVal) {
            this.searchForm2.startTime = newVal[0]
            this.searchForm2.endTime = newVal[1]
          } else {
            this.searchForm2.startTime = ''
            this.searchForm2.endTime = ''
          }
        },
        immediate: true // 如果你希望在组件创建时立即执行一次
      }
    },
    created() {
      this.activeName = '1'
      this.getPromotionInformation()
    },
    methods: {
      onExport2() {
        let self = this;
        const Params = {
          ...self.searchForm
        }
        delete Params.applicationTime
        Params.token = getCookie('token');
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/api/shop/yxshopJdServiceProviderAuditRecord/export?' + qs.stringify(Params);
      },
      closeDialogFunc() {
        this.showJdLoginModal = false
      },
      synchronous() {
        const self = this
        self.btnLoading = true
        jingdongApi.syncJddjData({}).then(res => {
          if (res.code === 1) {
            if (res.data.code === 1) {
              self.$message.success('同步成功')
              self.onSearch2()
            } else {
              self.$message.warning(res.data.msg)
              setTimeout(() => {
                self.openCookieModal()
                self.btnLoading = false

              }, 500);
            }
          }
          self.btnLoading = false

        }).catch(err => {
          self.btnLoading = false
        })
      },
      openCookieModal() {
        console.log(432432)
        this.jddjCookies = ''
        this.showJdLoginModal = true
      },
      saveCookie() {
        const self = this
        self.loading = true
        jingdongApi.saveJddjCookiesSetting({
          jddjCookies: self.jddjCookies
        }).then(res => {
          if (res.code === 1) {
            self.$message.success('保存成功，请重新进行同步')
            this.cookieDialogVisible = false
          }
          self.loading = false

        }).catch(err => {
          self.loading = false
        })
      },
      beforeUpload(file) {
        const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const isXls = file.type === 'application/vnd.ms-excel'

        if (!isXlsx && !isXls) {
          this.$message.error('只能上传xlsx和xls格式的文件')
          return false
        } else {
          this.file = file
        }
      },
      onError(err, file, fileList) {
        this.$message.error('上传失败！')
      },
      onSuccess() {
        let self = this
        self.importLoading = true
        const formData = new FormData()
        formData.append('file', this.file)
        jingdongApi.importMerchant(formData).then(res => {
          if (res.code === 1) {
            self.$message.success('导入成功')
            self.curPage2 = 1;
            self.getTableData2();
          }
          self.importLoading = false

        }).catch(err => {
          self.importLoading = false

          // console.log(err)
        })
      },
      onSuccess2() {
        let self = this
        self.importLoading = true
        const formData = new FormData()
        formData.append('file', this.file)
        jingdongApi.importMerchantOrder(formData).then(res => {
          if (res.code === 1) {
            self.$message.success('导入成功')
            self.curPage2 = 1;
            self.getTableData2();
          }
          self.importLoading = false

        }).catch(err => {
          self.importLoading = false

          // console.log(err)
        })
      },

      handleChange(e) {
        console.log(e)
        this.categoryList = []
        this.contentForm.categoryId = ''
        this.getCategoryList(e)
      },

      getCategoryList(e) {
        jingdongApi.categoryPageList({
          pageIndex: 1,
          pageSize: 1000,
          type: e
        }).then((res) => {
          if (res.code === 1) {
            this.categoryList = res.data.records
          }
        })
      },

      // 获取推广信息
      getPromotionInformation() {
        this.loading = true
        jingdongApi.getJdSetting({}).then((res) => {
          if (res.code === 1) {
            this.form = res.data
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 获取佣金配置
      getCommissionConfiguration() {
        this.loading = true
        jingdongApi.getJdCommissionSetting({}).then((res) => {
          if (res.code === 1) {
            if (res.data && res.data.obj) {
              this.configurationData = res.data.obj
            } else {
              this.configurationData = []
            }
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      //获取月结配置
      getMonthCommissionConfiguration() {
        this.loading = true
        jingdongApi.getJdMonthCommissionSetting({}).then((res) => {
          if (res.code === 1) {
            if (res.data && res.data.obj) {
              this.monthData = res.data.obj
            } else {
              this.monthData = []
            }
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      cutTab() {
        if (this.activeName === '1') {
          this.getPromotionInformation()
        } else if (this.activeName === '2') {
          this.getCommissionConfiguration()
        } else if (this.activeName === '3') {
          this.getMonthCommissionConfiguration()
        } else if (this.activeName === '4') {
          this.getTableData()
        } else if (this.activeName === '5') {
          this.getTableData2()
        } else if (this.activeName === '6') {
          this.getTableData3()
        } else if (this.activeName === '7') {
          this.getTableData4()
        }
      },
      contentChangeFunc(e, name) {
        this.form[name] = e
      },
      contentChangeFunc2(e) {
        this.contentForm.content = e
      },
      handleInput(index, name, event) {
        const value = event;
        // 使用正则表达式验证输入是否为非负整数
        const validValue = value.replace(/[^0-9]/g, '');
        // 如果 validValue 为空，设置为 null，否则转换为数字
        this.configurationData[index][name] = validValue === '' ? null : Number(validValue).toString();
      },
      handleInput2(index, name) {
        // 只允许输入数字和小数点，保留两位小数
        this.configurationData[index][name] = this.configurationData[index][name].replace(/[^\d.]/g, ''); // 只保留数字和小数点
        this.configurationData[index][name] = this.configurationData[index][name].replace(/^\./g, ''); // 第一个字符不是小数点
        this.configurationData[index][name] = this.configurationData[index][name].replace(/\.{2,}/g, '.'); // 不允许多个小数点
        this.configurationData[index][name] = this.configurationData[index][name].replace('.', '$#$').replace(/\./g, '')
          .replace('$#$', '.'); // 只保留一个小数点
        this.configurationData[index][name] = this.configurationData[index][name].replace(/^(\-)*(\d+)\.(\d\d).*$/,
          '$1$2.$3'); // 只保留两位小数
      },
      handleInput3(index, name, event) {
        const value = event;
        // 使用正则表达式验证输入是否为非负整数
        const validValue = value.replace(/[^0-9]/g, '');
        // 如果 validValue 为空，设置为 null，否则转换为数字
        this.monthData[index][name] = validValue === '' ? null : Number(validValue).toString();
      },
      handleInput4(index, name) {
        // 只允许输入数字和小数点，保留两位小数
        this.monthData[index][name] = this.monthData[index][name].replace(/[^\d.]/g, ''); // 只保留数字和小数点
        this.monthData[index][name] = this.monthData[index][name].replace(/^\./g, ''); // 第一个字符不是小数点
        this.monthData[index][name] = this.monthData[index][name].replace(/\.{2,}/g, '.'); // 不允许多个小数点
        this.monthData[index][name] = this.monthData[index][name].replace('.', '$#$').replace(/\./g, '').replace('$#$',
          '.'); // 只保留一个小数点
        this.monthData[index][name] = this.monthData[index][name].replace(/^(\-)*(\d+)\.(\d\d).*$/,
          '$1$2.$3'); // 只保留两位小数
      },
      handleInput5() {
        // 只允许输入数字和小数点，保留两位小数
        this.auditForm.money = this.auditForm.money.replace(/[^\d.]/g, ''); // 只保留数字和小数点
        this.auditForm.money = this.auditForm.money.replace(/^\./g, ''); // 第一个字符不是小数点
        this.auditForm.money = this.auditForm.money.replace(/\.{2,}/g, '.'); // 不允许多个小数点
        this.auditForm.money = this.auditForm.money.replace('.', '$#$').replace(/\./g, '')
          .replace('$#$',
            '.'); // 只保留一个小数点
        this.auditForm.money = this.auditForm.money.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只保留两位小数
      },
      onSubmit(type) {
        if (type === 1) {
          this.$refs.form.validate((valid) => {
            if (valid) {
              this.submitLoading = true
              jingdongApi.saveJdSetting(this.form).then((res) => {
                if (res.code === 1) {
                  this.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                }
                this.submitLoading = false
              }).catch(() => {
                this.submitLoading = false
              })
            }
          })
        } else if (type === 2) {
          let isValid = true; // 标记是否有效
          let errorMessage = ''; // 存储错误信息
          this.configurationData.forEach((item, index) => {
            // 检查必填项
            if (item.startMerchant === null || item.endMerchant === null || item.informationMoney === null || item
              .userProductMoney === null || item.platformProductMoney === null || item.direct === null || item
              .indirect === null) {
              isValid = false;
              errorMessage += `第 ${index + 1} 行的所有字段都是必填的。\n`;
            }
            // 检查 startMerchant 是否大于 endMerchant
            if (item.startMerchant !== null && item.endMerchant !== null && Number(item.startMerchant) > Number(item
                .endMerchant)) {
              isValid = false;
              errorMessage += `第 ${index + 1} 行的开始商家数量不能大于结束商家数量。\n`;
            }
          });

          if (!isValid) {
            this.$message({
              message: errorMessage,
              type: 'error'
            });
            return; // 阻止提交
          }
          console.log(this.configurationData)
          this.submitLoading = true
          jingdongApi.saveJdCommissionSetting({
            obj: this.configurationData
          }).then((res) => {
            if (res.code === 1) {
              this.$message({
                message: '设置成功',
                type: 'success'
              });
            }
            this.submitLoading = false
          }).catch(() => {
            this.submitLoading = false
          })
        } else if (type === 3) {
          jingdongApi.saveJdMonthCommissionSetting({
            obj: this.monthData
          }).then((res) => {
            if (res.code === 1) {
              this.$message({
                message: '设置成功',
                type: 'success'
              });
            }
            this.submitLoading = false
          }).catch(() => {
            this.submitLoading = false
          })
        }

      },
      addTable() {
        this.configurationData.push({
          startMerchant: null,
          endMerchant: null,
          informationMoney: null,
          productMoney: null,
          direct: null,
          indirect: null
        })
      },
      addTable2() {
        this.monthData.push({
          startOrder: null,
          endOrder: null,
          money: null
        })
      },
      delTable(index) {
        this.configurationData.splice(index, 1)
      },
      delTable2(index) {
        this.monthData.splice(index, 1)
      },
      onExport() {
        let self = this;
        self.exportLoading = true
        let search = this.searchForm;
        delete search.applicationTime
        search.token = getCookie('token');
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/api/shop/jdMerchant/export?' + qs.stringify(search);
        setTimeout(() => {
          self.exportLoading = false;
        }, 3000);
      },

      onSearch() {
        this.curPage = 1
        this.getTableData()
      },

      onSearch2() {
        this.curPage2 = 1
        this.getTableData2()
      },
      onSearch3() {
        this.curPage3 = 1
        this.getTableData3()
      },
      onSearch4() {
        this.curPage4 = 1
        this.getTableData4()
      },

      getTableData() {
        let self = this;
        self.loading = true
        let Params = {
          ...self.searchForm
        };
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        delete Params.applicationTime

        jingdongApi.jdMerchantPage(Params, true)
          .then(res => {
            self.tableData = res.data.records;
            self.totalDataNumber = res.data.total
            self.loading = false
          })
          .catch(error => {
            self.loading = false
          });
      },
      getTableData2() {
        let self = this;
        self.loading = true
        let Params = {
          ...self.searchForm2
        };
        Params.pageIndex = self.curPage2;
        Params.pageSize = self.pageSize2;
        delete Params.createTime
        jingdongApi.jdMerchantPage2(Params, true)
          .then(res => {
            self.tableData2 = res.data.records;
            self.totalDataNumber2 = res.data.total
            self.loading = false
          })
          .catch(error => {
            self.loading = false
          });
      },
      getTableData3() {
        let self = this;
        self.loading = true
        let Params = {
          ...self.searchForm3
        };
        Params.pageIndex = self.curPage3;
        Params.pageSize = self.pageSize3;
        jingdongApi.categoryPageList(Params, true)
          .then(res => {
            self.tableData3 = res.data.records;
            self.totalDataNumber3 = res.data.total
            self.loading = false
          })
          .catch(error => {
            self.loading = false
          });
      },
      getTableData4() {
        let self = this;
        self.loading = true
        let Params = {
          ...self.searchForm4
        };
        Params.pageIndex = self.curPage4;
        Params.pageSize = self.pageSize4;
        jingdongApi.contentPage(Params, true)
          .then(res => {
            self.tableData4 = res.data.records;
            self.totalDataNumber4 = res.data.total
            self.loading = false
          })
          .catch(error => {
            self.loading = false
          });
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableData();
      },
      handleCurrentChange2(val) {
        let self = this;
        self.curPage2 = val;
        self.loading = true;
        self.getTableData2();
      },
      handleCurrentChange3(val) {
        let self = this;
        self.curPage3 = val;
        self.loading = true;
        self.getTableData3();
      },
      handleCurrentChange4(val) {
        let self = this;
        self.curPage4 = val;
        self.loading = true;
        self.getTableData4();
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableData();
      },
      handleSizeChange2(val) {
        this.curPage2 = 1;
        this.pageSize2 = val;
        this.getTableData2();
      },
      handleSizeChange3(val) {
        this.curPage3 = 1;
        this.pageSize3 = val;
        this.getTableData3();
      },
      handleSizeChange4(val) {
        this.curPage4 = 1;
        this.pageSize4 = val;
        this.getTableData4();
      },
      audit(row, type) {
        this.selectData = row
        this.type = type
        this.auditForm.status = ''
        this.auditForm.reason = ''
        this.auditForm.imgs = []
        if (type === 3) {
          let Params = {
            id: row.id
          };
          jingdongApi.getMonthMerchantMoney(Params, true)
            .then(res => {
              this.auditForm.money = res.data
            })
          this.auditForm.orderNum = row.orderNum
        }
        this.dialogVisible = true
      },
      look(row) {
        this.selectData = row
        this.lookdialogVisible = true
      },
      deleteImg(index) {
        this.auditForm.imgs.splice(index, 1);
      },
      openProductUpload(file_type, file_name) {
        this.file_name = file_name;
        if (file_type == 'image') {
          this.config = {
            total: 9,
            fileType: 'image'
          };
        } else {
          this.config = {
            total: 1,
            fileType: 'video'
          };
        }
        this.isProductUpload = true;
      },
      returnProductImgsFunc(e) {
        if (e != null) {
          let imgs = []
          imgs = this.auditForm.imgs.concat(e);
          for (let i = 0; i < imgs.length; i++) {
            if (typeof(imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.auditForm, 'imgs', imgs);
        }
        this.isProductUpload = false;
      },
      goAudit() {
        console.log(this.selectData)
        console.log(this.auditForm)
        let params = {
          id: this.selectData.id
        }
        if (this.type === 1) {
          params.informationStatus = this.auditForm.status
          params.informationExamineReason = this.auditForm.reason
          if (this.auditForm.imgs && this.auditForm.imgs.length) {
            let arr = []
            this.auditForm.imgs.forEach((item) => {
              arr.push(item.imageId)
            })
            params.informationExamineImages = arr
          } else {
            params.informationExamineImages = []
          }
        }
        if (this.type === 2) {
          params.productStatus = this.auditForm.status
          params.productExamineReason = this.auditForm.reason
          if (this.auditForm.imgs && this.auditForm.imgs.length) {
            let arr = []
            this.auditForm.imgs.forEach((item) => {
              arr.push(item.imageId)
            })
            params.productExamineImages = arr
          } else {
            params.productExamineImages = []
          }
        }
        if (this.type === 1 || this.type === 2) {
          jingdongApi.jdMerchantExamine(params, true)
            .then(res => {
              if (res.code === 1) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              }
              this.curPage = 1;
              this.getTableData();
              this.dialogVisible = false
            })
        } else if (this.type === 3) {
          //发放月结金额
          params.money = this.auditForm.money
          jingdongApi.payMonthMerchantMoney(params, true)
            .then(res => {
              if (res.code === 1) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
              }
              this.curPage = 1;
              this.getTableData();
              this.dialogVisible = false
            })
        }
      },
      showCategoryModal(formName) {
        this.categoryModalVisible = true
        this.categoryForm = {
          id: '',
          type: '',
          name: '',
          status: 1
        }
      },
      showContentModal() {
        this.categoryList = []
        this.contentForm = {
          id: '',
          type: '',
          categoryId: '',
          content: ''
        }
        this.contentModalVisible = true
        this.contentForm.resetFields()
      },
      saveCategory() {
        this.$refs.categoryForm.validate((valid) => {
          if (valid) {
            console.log(this.categoryForm)
            this.submitLoading = true
            jingdongApi.saveJdCategory(this.categoryForm).then((res) => {
              if (res.code === 1) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.curPage3 = 1
                this.categoryModalVisible = false
                this.$refs.categoryForm.resetFields();
                this.getTableData3()
              }
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          }
        })
      },
      editCategory(row) {
        this.categoryModalVisible = true
        this.categoryForm = {
          id: row.id,
          type: row.type,
          name: row.name,
          status: row.status
        }
      },
      delCategory(row) {
        let self = this;
        self
          .$confirm('确认删除当前类目,?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            jingdongApi.deleteJdCategory({
                  ids: [row.id]
                },
                true
              )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  self.getTableData3();
                } else {}
              })
              .catch(error => {});
          })
          .catch(() => {});
      },
      changeStatus(row) {
        this.loading = true
        jingdongApi.saveJdCategory({
          ...row
        }).then((res) => {
          if (res.code === 1) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getTableData3()
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      saveContent() {
        this.$refs.contentForm.validate((valid) => {
          if (valid) {
            console.log(this.contentForm)
            this.submitLoading = true
            jingdongApi.saveJdCategoryContent(this.contentForm).then((res) => {
              if (res.code === 1) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.curPage4 = 1
                this.contentModalVisible = false
                this.$refs.contentForm.resetFields();
                this.getTableData4()
              }
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          }
        })
      },
      editContent(row) {
        const data = JSON.parse(JSON.stringify(row))
        this.contentModalVisible = true
        this.contentForm = data
        this.getCategoryList(data.type)
      },
      delContent(row) {
        let self = this;
        self
          .$confirm('确认删除当前内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            jingdongApi.deleteJdCategoryContent({
                  ids: [row.id]
                },
                true
              )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  self.getTableData4();
                } else {}
              })
              .catch(error => {});
          })
          .catch(() => {});
      },
    }
  }
</script>

<style lang="scss" scoped>
  .table-wrap {
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;

    .item {
      width: 33%;
      margin-bottom: 20px;
      display: flex;

      .name {
        color: #999;
        white-space: nowrap;
      }
    }
  }

  .jd {
    /deep/ .el-tabs__content {
      height: calc(100vh - 175px);
      overflow-y: auto;
    }

    .common-button-wrapper {
      position: sticky;
      bottom: 0;
    }

    /deep/ .edui-editor {
      width: 95% !important;
    }

    .line {
      margin: 0 10px;
    }
  }

  /deep/ .el-dialog {
    margin-top: 5vh !important;
  }

  /deep/ .edui-editor-iframeholder {
    width: 100% !important;
  }

  .mt {
    display: flex;
  }

  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/jingdong/index.vue